/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Dialogue_List_Export_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Dialogue List Export failed: {error}" |
*
* @param {Dialogue_List_Export_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_failed_toast = /** @type {((inputs: Dialogue_List_Export_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de l'exportation de la liste des dialogues : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Dialoglistenexport fehlgeschlagen: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Esportazione elenco dialoghi fallita: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Экспорт списка диалогов не удался: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error en la exportación de la lista de diálogo: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`对话列表导出失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ダイアログリストのエクスポートに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`संवाद सूची निर्यात विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha na exportação da lista de diálogos: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Dialogue List Export failed: ${i?.error}`)
});